import { element } from '../../../core/elements';
import { Bar } from '../../../primitives/shape/Bar';
import Group from '../../../primitives/shape/Group';
import { CORNER_RADIUS_VALUE } from '../../common/constants/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const BarGroupMarks = element(function BarGroupMarks(_ref) {
  let {
    barGroups,
    roundedCorners = false
  } = _ref;
  return barGroups.map(barGroup => {
    return /*#__PURE__*/_jsx(Group, {
      left: barGroup.x0,
      children: barGroup.bars.map(bar => {
        const cornerRadius = roundedCorners && bar.height > 2 * CORNER_RADIUS_VALUE.SMALL && bar.width > 2 * CORNER_RADIUS_VALUE.SMALL ? CORNER_RADIUS_VALUE.SMALL : CORNER_RADIUS_VALUE.NONE;
        return /*#__PURE__*/_jsx(Bar, {
          ariaLabel: `${bar.label}, x: ${bar.xValue}, y: ${bar.yValue}`,
          x: bar.x,
          y: bar.y,
          datum: bar.datum,
          width: bar.width,
          height: bar.height,
          fill: bar.color,
          cornerRadius: {
            topLeft: cornerRadius,
            topRight: cornerRadius
          }
        }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
      })
    }, `bar-group-marks-${barGroup.index}-${barGroup.x0}`);
  });
});